import { Point } from '@printu/geom';
import { ProjectActions } from 'app/stores/project/actions';
import { getInsertStyle } from 'app/stores/selectors';
const LengthThreshold = 4;
export const InsertConvex = (markerFactory) => (dispatch, getState) => {
    const state = getState();
    const { size, color, sizeFactor } = getInsertStyle(state);
    const onDragStart = (payload, point) => {
        var _a, _b;
        const marker = markerFactory(point, size, sizeFactor, color);
        payload.itemId = marker.id;
        const markerSize = (_a = marker.size) !== null && _a !== void 0 ? _a : size;
        marker.size = markerSize / sizeFactor;
        const markerColor = (_b = marker.color) !== null && _b !== void 0 ? _b : color;
        marker.color = markerColor;
        dispatch(ProjectActions.itemInsert({
            marker,
            undoable: true,
        }));
    };
    const onDrag = (payload, point) => {
        const { itemId: id } = payload;
        if (id) {
            const { down } = payload;
            dispatch(ProjectActions.itemUpdate({
                id,
                patch: {
                    endX: point.x - down.x,
                    endY: point.y - down.y,
                },
                undoable: false,
            }));
        }
    };
    const onDragEnd = (payload, point) => {
        const { itemId: id } = payload;
        if (id) {
            const { down } = payload;
            if (Point.getDistance(down, point) < LengthThreshold) {
                dispatch(ProjectActions.deleteItems({ ids: [id] }));
            }
        }
    };
    return {
        onPointerDown: onDragStart,
        onPointerDrag: onDrag,
        onPointerUp: onDragEnd,
    };
};
